module.exports = __webpack_public_path__ + "img/notfound.325dca59.svg";